import React from 'react';
import PanelSlider from '../../PanelSlider';
import PromptSuggestion from '../PromptSuggestion';
const PromptSuggestionSlider = ({ suggestions })=>{
    return /*#__PURE__*/ React.createElement(PanelSlider, null, suggestions.map((suggestion, index)=>/*#__PURE__*/ React.createElement(PromptSuggestion, {
            key: `suggestion-${index}`,
            suggestion: suggestion
        })));
};
PromptSuggestionSlider.displayName = 'PromptSuggestionSlider';
export default PromptSuggestionSlider;

//# sourceMappingURL=PromptSuggestionSlider.js.map